import { render, staticRenderFns } from "./SocietyCompetitorsPopup.vue?vue&type=template&id=5b09a5bf&scoped=true"
import script from "./SocietyCompetitorsPopup.vue?vue&type=script&lang=js"
export * from "./SocietyCompetitorsPopup.vue?vue&type=script&lang=js"
import style0 from "./SocietyCompetitorsPopup.vue?vue&type=style&index=0&id=5b09a5bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b09a5bf",
  null
  
)

export default component.exports